import {
  put, all, call, takeLatest,
} from 'redux-saga/effects';
import mime from 'mime-types';
import qs from 'qs';
import { NetworkService, i18n, MessageService } from 'services';
import { saveBlacklist, saveCSVBlacklist, changeEndedStatus as changeBlacklistEndedStatus } from 'actions/blacklist/blacklistActionCreator';
import {
  changeLoadingState, setSuccessMessage, setErrorMessage, changeEndedStatus,
} from 'app/settings/slices';
import BlacklistActionType from 'actions/blacklist/blacklistActionType';
import { changePlayerActionEndedStatus, changePlayerDataUpdatedStatus } from 'actions/player/playerActionCreator';
import { AppConstants } from 'constants/index';
import { downloadFile, isJSON } from 'utils/utils';
import { getError, getMessage } from 'utils/helpers';

function* getBlacklist({ payload }) {
  try {
    const { params } = payload;
    const options = {
      params,
    };
    const { PlayersAdmin, Blacklist } = AppConstants.api;
    yield put(changeLoadingState(true));
    const { data } = yield call(NetworkService.makeAPIGetRequest, [PlayersAdmin, Blacklist, payload.data.brandId], options);
    yield put(changeLoadingState(false));
    yield put(saveBlacklist(data));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* exportBlacklist({ payload }) {
  try {
    const { params } = payload;
    const options = {
      params,
      responseType: 'blob',
      paramsSerializer: (param) => qs.stringify(param, { allowDots: true }),
    };
    const { PlayersAdmin, Blacklist, Export } = AppConstants.api;
    yield put(changeLoadingState(true));
    const { data, headers } = yield call(NetworkService.makeAPIGetRequest, [PlayersAdmin, Blacklist, Export, payload.data.brandId], options);
    downloadFile(data, i18n.t('blacklist'), mime.extension(headers['content-type']));
    yield put(changeLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* getCsvBlacklist({ payload }) {
  try {
    yield put(changeLoadingState(true));
    const { PlayersAdmin, Blacklist, Validate } = AppConstants.api;
    const options = {
      data: payload.data,
      headers: { 'content-type': 'multipart/form-data' },
    };
    const { data } = yield call(NetworkService.makeAPIPostRequest, [PlayersAdmin, Blacklist, Validate], options);
    yield put(saveCSVBlacklist(data));
    yield put(changeLoadingState(false));
    yield put(changeBlacklistEndedStatus(true));
    if (!data.length) {
      MessageService.error(i18n.t('notification:emptyFile'));
    }
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
      yield put(changeBlacklistEndedStatus(true));
    }
    yield put(changeLoadingState(false));
  }
}

function* deleteBlacklist({ payload }) {
  try {
    yield put(changeLoadingState(true));
    const { PlayersAdmin, Blacklist } = AppConstants.api;
    const options = {
      data: payload.data,
    };
    yield call(NetworkService.makeAPIDeleteRequest, [PlayersAdmin, Blacklist], options);
    yield put(changeEndedStatus(true));
    yield put(changeLoadingState(false));
    yield put(setSuccessMessage(getMessage(i18n.t('blacklist'), i18n.t('notification:slUpdated'))));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* importBlacklist({ payload }) {
  try {
    yield put(changeLoadingState(true));
    const { PlayersAdmin, Blacklist, Import } = AppConstants.api;
    const options = {
      data: payload.data,
    };
    yield call(NetworkService.makeAPIPutRequest, [PlayersAdmin, Blacklist, Import, payload.brandId], options);
    yield put(changeEndedStatus(true));
    yield put(changeLoadingState(false));
    yield put(setSuccessMessage(getMessage(i18n.t('blacklist'), i18n.t('notification:slUpdated'))));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* changePlayerBlacklistedStatus({ payload }) {
  try {
    const { playerId, params } = payload;
    yield put(changeLoadingState(true));
    const { PlayersAdmin, Actions, Blacklist } = AppConstants.api;
    const options = {
      params,
    };
    yield call(NetworkService.makeAPIPutRequest, [PlayersAdmin, Actions, Blacklist, playerId], options);
    yield put(changeLoadingState(false));
    yield put(setSuccessMessage(getMessage(i18n.t('account'), i18n.t(params.blacklist ? 'notification:slBlacklisted' : 'notification:slWhiteListed'))));
    yield put(changePlayerDataUpdatedStatus(true));
    yield put(changePlayerActionEndedStatus(true));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

export default function* blacklistSaga() {
  yield all([
    takeLatest(BlacklistActionType.GET_BLACKLIST, getBlacklist),
    takeLatest(BlacklistActionType.EXPORT_BLACKLIST, exportBlacklist),
    takeLatest(BlacklistActionType.GET_CSV_BLACKLIST, getCsvBlacklist),
    takeLatest(BlacklistActionType.DELETE_BLACKLIST, deleteBlacklist),
    takeLatest(BlacklistActionType.IMPORT_BLACKLIST, importBlacklist),
    takeLatest(BlacklistActionType.CHANGE_PLAYER_BLACKLISTED_STATUS, changePlayerBlacklistedStatus),
  ]);
}
